import {ReactElement, Suspense, useState} from "react";
import {Helmet} from "react-helmet-async";

import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {NavTabs} from "@/components/navTabs/NavTabs.tsx";
import {LoadingContainer} from "@/components/placeholder/LoadingContainer.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {UserProfileFormDetails} from "@/pages/accounts/userProfilePage/forms/UserProfileFormDetails.tsx";
import {UserProfileFormPassword} from "@/pages/accounts/userProfilePage/forms/UserProfileFormPassword.tsx";

export enum UserProfileTab {
  DETAILS = "DETAILS",
  PASSWORD = "PASSWORD",
}

const UserProfileTabContent: Record<UserProfileTab, ReactElement> = {
  [UserProfileTab.DETAILS]: <UserProfileFormDetails />,
  [UserProfileTab.PASSWORD]: <UserProfileFormPassword />,
};

export const UserProfilePage = () => {
  const [tab, setTab] = useState(UserProfileTab.DETAILS);

  return (
    <ContentContainer
      title="User Profile"
      extraHeaderContent={
        <NavTabs
          variant={"header"}
          items={[
            {
              title: "Details",
              id: UserProfileTab.DETAILS,
            },
            {
              title: "Password",
              id: UserProfileTab.PASSWORD,
            },
          ]}
          selectedId={tab as string}
          selectTab={(tab) => {
            setTab(tab as UserProfileTab);
          }}
        />
      }
    >
      <Helmet>
        <title>User Profile</title>
      </Helmet>
      <UpErrorBoundary>
        <Suspense fallback={<LoadingContainer />}>{UserProfileTabContent[tab]}</Suspense>
      </UpErrorBoundary>
    </ContentContainer>
  );
};
